// AI-CONTEXT: See docs/test-runs/2026-10-20-rapportage-per-deelnemer.md (B3)
// Eén melding voor alle deelnemerwidgets zonder deelnemer op het rapport —
// ze zeiden het elk anders, en geen van vieren zei wáár je hem kiest.

/** Wat een deelnemerwidget toont als het rapport geen deelnemer heeft. */
const NO_PERSONA_TEXT = "Deze widget gaat over één deelnemer. Kies bovenaan het rapport bij 'Deelnemer' over wie het rapport gaat.";

export default NO_PERSONA_TEXT;
